<template>
  <div>
    <div class="tabs hide-small">
      <div :class="[ tab === 'main' ? 'active' : '' ]" @click="tab = 'main'">Main details</div>
    </div>
    <div class="tabs tabs-right hide-small">
      <div :class="[ isValid ? 'valid' : 'disabled', 'save-tab' ]" @click="save(false)">{{ saveOrUpdate }}</div>
      <div :class="[ isValid ? 'valid' : 'disabled', 'save-tab' ]" @click="save(true)">{{ saveOrUpdate }} &amp; exit</div>
    </div>
    <div class="dropdown show-small dropdown-admin-tabs">
      <button class="btn dropdown-toggle" type="button" data-toggle="dropdown">
        Options
        <span class="caret"></span>
      </button>
      <ul class="dropdown-menu">
        <li @click="tab = 'main'">
          <a href="#">
            Main details
            <i class="fa fa-check-square-o" v-if="tab === 'main'"></i>
          </a>
        </li>
        <li :class="[ isValid ? 'valid' : 'disabled', 'save-dropdown' ]" @click="save(false)"><a href="#">{{ saveOrUpdate }}</a></li>
        <li :class="[ isValid ? 'valid' : 'disabled', 'save-dropdown' ]" @click="save(true)"><a href="#">{{ saveOrUpdate }} &amp; exit</a></li>
      </ul>
    </div>
    <section id="main-content" class="clearfix">
      <div class="clearfix" slot="admin-content" id="location-content">
        <div v-if="tab === 'main'">
          <div class="col-xs-12 col-sm-6 main-location-details left top-small">
            <div class="form-group">
              <label for="tm-dist" class="form-label">Distance *</label>
              <input step="0.01" type="number" class="form-control" id="tm-dist" v-model="entity.distance"/>
            </div>
            <div class="form-group">
              <label class="form-label">Origin Location *</label>
              <autocomplete
                :dataset="locationSearchResults"
                title="Origin Location"
                placeHolder="Type to search"
                :initVal="entity.originLocation"
                v-on:changing="data => locationSearchText = data"
                :fnFormatText="displayLocation"
                :fnSelectValue="displayLocation"
                v-on:selection-made="selectOrigin"
              ></autocomplete>
            </div>
          </div>
          <div class="col-xs-12 col-sm-6 main-location-details left bottom-small">
            <div class="form-group">
              <label class="form-label">Destination Location *</label>
              <autocomplete
                :dataset="locationSearchResults"
                title="Origin Location"
                placeHolder="Type to search"
                :initVal="entity.destinationLocation"
                v-on:changing="data => locationSearchText = data"
                :fnFormatText="displayLocation"
                :fnSelectValue="displayLocation"
                v-on:selection-made="selectDestination"
              ></autocomplete>
            </div>
            <div class="form-group">
              <label for="pa-ext" class="form-label">External ID</label>
              <input type="text" class="form-control" id="pa-ext" v-model="entity.externalId"/>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
  import AdminEntityMixin from '../../mixins/AdminEntityMixin'
  import Autocomplete from '../../../helpers/AutoComplete.vue'
  import HelperMixin from '../../mixins/Helpers'
  export default {
    name: 'TransitMile',
    mixins: [AdminEntityMixin, HelperMixin],
    data () {
      return {
        transformForUpdate: {
          originLocation: this.toMinus,
          destinationLocation: this.toMinus,
          distance: this.toZero,
          externalId: this.toZero
        },
        newEntityScreen: 'Admin - Transit Miles',
        editEntityScreen: 'Admin - Edit/View Transit Mile',
        tab: 'main',
        entity: {
          id: null,
          originLocation: null,
          destinationLocation: null,
          externalId: null,
          distance: null
        },
        entityName: 'transit-miles',
        boxes: []
      }
    },
    components: {
      Autocomplete
    },
    computed: {
      isValid () {
        return this.entity.distance && this.entity.originLocation && this.entity.destinationLocation
      }
    },
    methods: {
      selectOrigin (o) {
        this.entity.originLocation = o
        this.locationSearchText = ''
        this.locationSearchResults = []
      },
      selectDestination (d) {
        this.entity.destinationLocation = d
        this.locationSearchText = ''
        this.locationSearchResults = []
      },
      getBaseData () {
        return {
          id: null,
          originLocation: null,
          destinationLocation: null,
          externalId: null,
          distance: null
        }
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/modules/admin/components/TransitMile/TransitMile.vue